import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'
import VueRouter from 'vue-router'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import store from './store/index'
import apiFun from "./network/api";  // 导入API模块
import Video from '../node_modules/video.js'
import '../node_modules/video.js/dist/video-js.css'
import WatermarkDirective from './common/watermark'
// 注册水印指令
Vue.use(WatermarkDirective)
// 1. 先给Vue原型挂载属性和方法
Vue.prototype.$video = Video
Vue.prototype.$apiFun = apiFun;  // 关键：移到new Vue()之前

// 2. 安装插件
Vue.use(VueRouter);
Vue.use(Element);

Vue.config.productionTip = false

// 3. 最后实例化Vue
new Vue({
  el: '#app',
  store,
  render: h => h(App),
  router: router,
})